import type React from 'react';

import { Image, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import type { SocialPostPlatformId } from '../../../../hooks/useSocialPostUrlForm/platforms';
import { SourceIcon } from '../../../SourceIcon';

/** The source's name behind a badge showing the outlet's logo, or the platform icon without one. */
export const SourceLine: React.FC<Props> = ({ platform, label, logo }) => (
	<div className="flex items-center gap-1">
		<div
			data-qa="social-post-chip-source-badge"
			className={cn(
				'flex h-4 w-4 shrink-0 items-center justify-center overflow-hidden rounded-md',
				logo ? 'bg-fill-weaker' : 'bg-fill-strong',
			)}
		>
			{logo ? (
				<Image
					src={logo}
					alt=""
					aspectRatio="1:1"
					className="h-full w-full object-cover"
					fallback={<SourceIcon platform={platform} size={10} className="text-icon-strong" />}
				/>
			) : (
				<SourceIcon platform={platform} size={10} className="text-icon-inverse-strong" />
			)}
		</div>
		<Text as="p" className="text-typography-weak line-clamp-2 break-words" size="x-small">
			{label}
		</Text>
	</div>
);

type Props = Readonly<{
	platform: SocialPostPlatformId;
	label: string;
	logo: string | undefined;
}>;
